import {  Link } from "react-router-dom"


import history from '../../../history'





import MotelTerrain from '../../terrain/MotelTerrain'
   //import FacetBar from '../../esfind/FacetBar'
  

   import {SV_SOJ_ORCMOCK_ADDRESS} from '../../../constants'
   import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';
   import ErrorCom from '../../core/AbodeErrorTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner'
/*svj16 start*/
import AmbItnSVPriceListView from '../../amb/AmbItnSVPriceListView'
//import svgetitn  from '../../../svgetitn.json'
/*svj16 end*/

//import TerrainLocationListView from '../../terrain/TerrainLocationListView'
import '../../../css/svdreact.css'
import '../../../css/OrderDet.css'

   const React = require('react')
   const _ = require('lodash')


 
   

   const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );

   const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

  
class TpOrderDetail extends React.Component {
    constructor(props){

        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(this) 
        this.closecbParent = this.closecbParent.bind(this)
        this.morderItnsView = this.morderItnsView.bind(this)
       
   
        this.getChildBody = this.getChildBody.bind(this)
      
        this.getChildContainersDetail = this.getChildContainersDetail.bind(me)
    }

    morderItnsView( svcustProfile, reservekey, legs){
        
        if(legs &&  (legs.length < 1 ) ){
            return (<div></div>)
        }
        return legs.map( (itn, idx) =>{
               if(idx == 0){
                return (<AmbItnSVPriceListView   svitn={itn} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbItnSVPriceListView>
                    )
               }else{
                return (<AmbItnSVPriceListView  svitn={itn} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbItnSVPriceListView>
                    )
               }
                

        })

    }

    getAppDetails(paramQSpaceId, svtv, orderId){
        console.log('order detail confirmationcode**************', paramQSpaceId)
        /*sva*/
        if(orderId < 0){
            console.log("id*  cerate ******", orderId)
            this.props.svLoadReviewdetReset()
        }else{

          console.log("id* addressr det or edit******", orderId)
          this.props.loadTpOrderderNowSecure(orderId,svtv)
        }

        //this.props.loadOrderderNowSecure(orderId,svtv)
        /*svae*/
        // this.props.getSoDetails("mancreek")
 
       // this.props.ordAndImagesSV()
        
     }
     closecbParent(){
        let svCustomerId = this.props.svparams.id
        console.log('svCustomerId orderdeatils*********')
        console.log(svCustomerId)
        history.push(`/myreservationsSV/${svCustomerId}`)
      }
     componentWillMount()	{
        console.log('sv--TpOrderDetails=--- link sends us params')
        let id, orderId;
        console.log(this.props)
        if(this.props.svparams){
           id = this.props.svparams.id
        
        }else{
         console.log('not called by router we might be creat')
         id = -11;
        }

        if(this.props.svparams.orderId){
            orderId = this.props.svparams.orderId
         
         }else{
          console.log('not called by router we might be creat')
          orderId = -11;
         }
       
   console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
   
   
   const { cookies } = this.props;
   this.getAppDetails(id, cookies.get('svt'), orderId)
     }

     render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title, orders} = this
        let svCustomerId = this.props.svparams.id

        return (

            
            <div className="col-md-12">

    
                
                <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersDetail(svCustomerId)}></MotelTerrain>
            </div>
        )

    }

    getChildBody() {
        //svj16start
        /*
        let itineraries = svgetitn.itineraries
        let productId = productId

        let svcustProfile= {"customerId":"102"}
        */
        let itineraries = null
        let productId = -1

        let svcustProfile= {"customerId":"102"}
       
       
        let reservekey = 'insvreviewodet'
        //svj16end
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title} = this
        let data = [], hosts = [], dbs = [], sojourns = [] ,my_data = []
       
        let my_data_flyreview ={
            "Request": {
                "checkin": "OK",
                "stay": "6",
                "stayInit": "nights",
                "checkout": "UU12345",
                "checkinTime": "Sat, Sept 9, 3027",
                "checkinTimePrefix": "From 3:00 PM",
                "checkoutTimePrefix": "Until 11:00 AM",
                "checkoutTime": "Sat, Sept 16, 3027"
            },
            "spaceDet": {
            
                "space_details": "Queen Room with Two Queen Beds",
                "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                "cancellation": "Free cancellation before December 9, 2024 ",
                "guests": "2 adults ",
                "cleaniness_score" : "7.7",
                "non_smoking":true,
        
                "space_amenity_name": [
                    "300 feet elevator",
                    "air conditioning",
                    "private bathroom"
                ]
               
               
            },
            "booking": {
                airlines_code_iata: 4,
                airlines_db_id: 146,
                airlines_name: "Air Salone",
                airlines_name_iata: "2O",
                airlines_vessel: "CR9",
                airport_id: 30009,
                destcity: "1@4@1@ADQ",
                dst_airport_code: "MMM",
                enddate: "2026-12-01",
                flightSpaceKey: "99@99@1@ADQD",
                flight_airline_num_stops: 1,
                flight_arrival: "04:30",
                flight_arrival_date: "2025-10-26",
                flight_arrival_daytime: "PM",
                flight_arrival_time: "04:30",
                flight_arrival_time_tzest: "2025-10-26T16:30:00-0400",
                flight_departure: "10:30",
                flight_departure_date: "2025-10-25",
                flight_departure_daytime: "AM",
                flight_departure_time: "10:30",
                flight_departure_time_tzest: "2025-10-25T10:30:00-0400",
                flight_operated_by: "4009 operated by Envoy Airlines",
                flight_operator_owned: "Y",
                flight_space_id: 13,
                flight_space_key: "1@4@1@ADQ",
                flight_time: 209,
                flight_time_hhmm: "6hr 29min",
                org_aiport_csc_addr: "HOMER,ALASKA,USA",
                origin_airport_city: "HOMER",
                origin_airport_code: "09A",
                origin_airport_country: "USA",
                origin_airport_iata: "09A",
                origin_airport_state: "ALASKA",
                origin_airport_timezone: "America/New_York",
                origincity: "HOMER",
                port_code_iata: 30009
                
               
            },
            "price": {
                "total": "$923",
                "depositValue":"$200.26",
                "depositName":"Damage Deposit (Fully refundable)",
                "currency": "usd",
                "tax": {
                   
                    "taxTotal": "$102.34",
                    "maintax": "$49.08",
                    "citytax": "$53.26",
        
                    "taxPercent": "6",
                    "citytaxPercent": "6.5"
                }
            },
            "id": "addLeft_step",
            "gene": "addLeft_step",
            "dcountry": "China",
            "privateparking":false,
            "rentcar":false,
            "bookTaxi":false,
            "needFlight":false,
            "arrivalTimeZone":"tz_pst",
            "fname": "John",
            "lname": "Glen",
            "email": "john123@yahoo.com",
            "address": "Glen",
            "city": "Glen",
            "state": "Glen",
            "zip": "12110",
            "country": "Glen",
            "isdcode": "+1",
            "phone": "Glen",
            "bookingAgentType": "self",
            "traveType": "Personal",
            "specialRequests": "Wheel chair and Senior Citizen",
            "gname": "Glen",
            "gemail": "Glen@yahoo.com",
            "card": "1234-1234--1234--1234",
            "cvv": "Glen",
            "mmexp": "04",
            "yyyyexp": "2028"
        }
        let price = null 
        let soj = my_data_flyreview.booking
        if (this.props.my_data_flyreview ) {
            my_data_flyreview = this.props.my_data_flyreview
            soj = my_data_flyreview.booking
          
       
        }

        if(my_data_flyreview && my_data_flyreview.price){
            price = my_data_flyreview.price
        }
        let svr_location = {
            "flight_space_key": soj['flightSpaceKey'] ? soj['flightSpaceKey'] : "54@1515@81@BLD",
            "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
            "county": soj['county'] ? soj['county'] : "albanyt",
            "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
            "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
            "country": soj['country_name'] ? soj['country_name'] : "usa",
           "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
           "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
            
           "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
           "state":soj['state'] ? soj['state'] : "NY"

        }
        svr_location = _.merge(svr_location, soj)
        console.log(soj)
        
        console.log(svr_location)
        /*
        let orderItem = {
            "orderId": -2,
            "productId": 1,
            "customerId": 6,
            "itemId": 1,
            "itemOrderQuantity": 1,
            "orderItemStatusCode": 1,
            "discountPrice": 0,
            "discountPercent": null,
            "taxPercent": 6.5,
            "cityTaxPercent": 6,
            "deposit": 200,
            "depositPercent": 0,
            "basePrice": 800,
            "salePrice": 1000,
            "total": 0,
            "reservationConfirmCode": "GHLKX",
            "currency": "USD",
            "createdDate": null,
            "modifiedDate": null,
            "createdBy": null,
            "modifiedBy": null,
            "spaceKey": "10000295@4@F@10@10@20251124@7@Y@SVR",
            "abodeSpaceId": "10000295",
            "cardId": 6,
            "addressId": 8,
            "name": "mat beta",
            "fname": "mat",
            "lname": "beta",
            "phone": "5121231237",
            "email": "mat11@br.com",
            "address": "12 linc",
            "city": "san jose",
            "state": "ca",
            "country": "usa",
            "zipcode": "95122",
            "startDate": "2024-11-24",
            "endDate": "2024-12-01"
        };
        */
        let orderItem = {};

        if(my_data_flyreview && my_data_flyreview.orderItem){
            orderItem = my_data_flyreview.orderItem
        }
        /*svj16 start*/
        if(my_data_flyreview && my_data_flyreview.dbitns){
            itineraries = my_data_flyreview.dbitns.itineraries
            productId = my_data_flyreview.dbitns.productId
        }
        let itn = itineraries
         /*svj16 end*/
        console.log('**************SV MERGE OCT4***')
        console.log('sv***OCT8*****', orderItem)
        soj = soj ? soj : {}
         reservekey = 'insvresdet'

       /*to do we donot neeed care - terrain is card . just planin textstyel images page to hsow terrrain  */
    
       const svmsg = "There is error . Plese try later"
       if(this.props.errorORDERDET){
         console.log('sv**container ger errob')
         console.log(this.props)
        return (
          <div >
             
              <div style={{paddingTop:'10px'}}>
                <ErrorCom  closecbParent={this.closecbParent} errob={this.props.errob} ></ErrorCom>
              </div>
              <div style={{paddingTop:'10px'}}>
                  <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svlogin`}> My Reservations   </Link></SVAButton>
              </div>
             
           </div>   
             )

       }else if(this.props.loadingORDERDET ){
        return (

          <div >
          <h3>Spinner*****</h3>
         <div style={{paddingTop:'10px'}}>

         <SVAbodeSpinner />
         </div>
 
      </div>   

        
              )

       }else {
          return (

            
           
    <div >
       {/*
        <TerrainLocation reservekey={reservekey}  svrlocation={svr_location}></TerrainLocation>
       
       */}
       
        <div className="svr-gal-contentWrapper">
            <article className="main">
            <div className="svr-header2" style={{marginLeft:'14px'}}>
            <p className="sd-content"> <text> Travel Details </text></p>
                    {
                     this.morderItnsView(svcustProfile, reservekey, itineraries)}
                    {/*  
                    <AmbItnSVPriceListView   svitn={itn} svcustProfile={svcustProfile} reservekey={reservekey}  ></AmbItnSVPriceListView>
               
                    */}
                 </div>
            <div className="svr-header2" style={{marginLeft:'14px'}}>
                       
                       
               <p className="sd-content"> <text> Order Status </text></p>
               <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Order# : {orderItem.orderId?orderItem.orderId:'O112234' } </text></span></p>
               <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>FlightSpaceKey# : {orderItem.flight_space_key?orderItem.flightSpaceKey	:'O112234' }   </text></span></p>
               <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>FlightSpaceId# : {orderItem.flightSpaceId	?orderItem.flightSpaceId		:'O112234' }   </text></span></p>
               <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Order Date : {orderItem.createdDate	?orderItem.createdDate		:'Friday, July 28, 2023 ' }  	  </text></span></p>
               <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Order Status : {orderItem.orderItemStatusCodeLabel ? orderItem.orderItemStatusCodeLabel: 'UNKNOWN' }     </text></span></p>
               <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Order Total : {price.total?price.total :'$200.26 ' }  </text></span></p>
               <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Base Price : {price.basePrice?price.basePrice :'$00.00 ' }  </text></span></p>
               <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Sale Price : {price.salePrice?price.salePrice :'$00.00 ' }  </text></span></p>
                  

            </div>
            <div className="svr-gal-box-row1">

                        <div className="o-container-sbar">

                            <div className="o-box-sbar">
                                <span className="o-span">
                                    <div>

                                        
                                        <p className="sd-content"> <text> Billing  Address </text></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}> {orderItem.fname	?orderItem.fname:'Allen' } {orderItem.lname	?orderItem.lname:'So' } </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>Email: {orderItem.email?orderItem.email:'janu@yahoo.com' }   </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>Phone: {orderItem.phone?orderItem.phone:' 511-123-9486' }  </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}> {orderItem.address?orderItem.address:'12 Lincon Street, san jose ' }  </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>{orderItem.state?orderItem.state:'ny' } , {orderItem.zipcode?orderItem.zipcode:'94022' }  </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>{orderItem.country?orderItem.country:'France' }  </text></span></p>
                <p className="sd-content"> <text> Payment   </text></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>Payment Method: Stripe </text></span></p>
                
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>Payment Status: Paid </text></span></p>
                
                                   
                                    </div>

                                </span>
                            </div>

                            <div className="o-box-sbar">
                                <span className="o-span">
                                    <div>
                                    <p className="sd-content"> <text> Shipping  Address </text></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}> {orderItem.shipmentFname	?orderItem.shipmentFname:'Allen' } {orderItem.shipmentLname	?orderItem.shipmentLname:'So' } </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>Email: {orderItem.shipmentEmail?orderItem.shipmentEmail:'allen@yahoo.com' } </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>Phone: {orderItem.shipmentPhone?orderItem.shipmentPhone:'512-123-9487' } </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>{orderItem.shipmentAddress?orderItem.shipmentAddress:'12 Scotlan Av  ' }  </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>{orderItem.state?orderItem.shipmentState:'ny' } , {orderItem.zipcode?orderItem.shipmentZipcode:'94022' }  </text></span></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>{orderItem.country?orderItem.shipmentCountry:'France' }  </text></span></p>
                <p className="sd-content"> <text> Shipment   </text></p>
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>Shipping Method: Standard </text></span></p>
                
                <p><span style={{fontSize: "16px"}} > <text style={{paddingLeft: "10px"}}>Shipping Status: Shipped </text></span></p>
                
                           
                                        


                                    </div>

                                </span>
                            </div>
                        
                        </div>



                 
            </div>
            <div className="svr-header2" style={{marginLeft:'14px'}}>
                       
                       
                        <p className="sd-content"> <text> Booking Information </text></p>
                <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Confirmation Code : {orderItem.reservationConfirmCode?orderItem.reservationConfirmCode:'RXUAB' }  </text></span></p>
             </div>
            <div className="svr-header2" style={{marginLeft:'14px'}}>
                       
                       
                        <p className="sd-content"> <text> Price Information </text></p>
                <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Include {price.taxTotal?price.taxTotal:'$102.34' } in taxes and fess </text></span></p>
                {/* 
                <p> <text className="tax-bl-total"> Incude {price.tax.taxTotal?price.tax.taxTotal:'$102.34' } in taxes and fess </text></p>
                 */}
                <p style={{paddingLeft: "10px"}}>
                <dl>
                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line" > {price.taxPercent?price.taxPercent :'$6' } % MainTAX </text></span></dt>
                    <dd className="tax-ib-amt"><span className="n2">{price.maintax?price.maintax:'$49.26' } </span> </dd>
                </dl>

                </p>
                <p style={{paddingLeft: "10px"}}>
                <dl>
                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line">{price.cityTaxPercent?price.cityTaxPercent :'6.5' }  % City TAX </text></span>
                    </dt>
                    <dd className="tax-ib-amt"><span className="n2"> {price.citytax?price.citytax :'$53.26' }  </span> </dd>
                </dl>
                </p>
                {/*  
                <p>
                <dl>

                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Damage Deposit (Fully
                                refundable) </text></span></dt>
                    <dd className="tax-ib-amt"><span className="n2"> {price.total?price.total :'$200.26 ' }</span> </dd>
                </dl>
                </p>
                */}
                <p style={{paddingLeft: "10px"}}><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(43, 127, 236)' }} type="diff" theme="filled" /><text style={{paddingLeft: "10px"}}>Damage Deposit (Fully  refundable)  {orderItem.depositWithCurrency?orderItem.depositWithCurrency :'$00.00 ' }</text></span></p>

                        
            </div>

            <div>
            <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svessearch`}> RE- ORDER   </Link></SVAButton>
            <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svessearch`}> CANCEL BOOKING  </Link></SVAButton>
            </div>
            </article>
           

        </div>
       
    </div>

     
          )
            }
     }
     getChildContainersDetail(customerId) {
       
        return (
            <div className="svr-det-pageWrapper">
                <header className="svr-header1">
                   <h1><span> <text style={{color:'#f0d8a9'}}> Order Detail  / Itineary Detail </text><Link to={`/myaccountSV/${customerId}/mysvspaceSearch`}><Icon  style={{ color: '#eeb838' }} type="plus-square" theme="filled" /> </Link><Link to={`/svlogin`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
            
                   
                </header>
                {this.getChildBody()}
             
           </div>   
             )   
      }

}

export default TpOrderDetail